<template>
  <v-footer fixed></v-footer>
</template>
<script>

export default {

  data: () => ({
  })
  ,
  methods: {
  },
  computed: {
  },
}
</script>
<style scoped lang="scss">
</style>
